import type { SVGProps } from "react";

export function ArrowNarrowLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92259 4.41058C9.24803 4.73602 9.24803 5.26366 8.92259 5.58909L5.34518 9.1665H16.6667C17.1269 9.1665 17.5 9.5396 17.5 9.99984C17.5 10.4601 17.1269 10.8332 16.6667 10.8332H5.34518L8.92259 14.4106C9.24803 14.736 9.24803 15.2637 8.92259 15.5891C8.59715 15.9145 8.06951 15.9145 7.74408 15.5891L2.74408 10.5891C2.41864 10.2637 2.41864 9.73602 2.74408 9.41058L7.74408 4.41058C8.06951 4.08514 8.59715 4.08514 8.92259 4.41058Z"
      />
    </svg>
  );
}
